import React from 'react';
import ManagementPage from './ManagementPage';
export default function PaymentCardsPage() { return <ManagementPage resource="cards" />; }
